import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ApiError } from '../api/errors';
import { useAuthStore } from '../stores/authStore';
import { useUiStore } from '../stores/uiStore';
import { c } from '../styles/theme';
import { paths } from './paths';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const completeProviderSignIn = useAuthStore((s) => s.completeProviderSignIn);
  const showToast = useUiStore((s) => s.showToast);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    async function run() {
      const query = new URLSearchParams(location.search);
      const code = query.get('code') ?? '';
      const state = query.get('state') ?? '';
      const providerError = query.get('error');
      if (providerError) {
        if (active) setError('Google sign-in was cancelled or refused.');
        return;
      }

      if (!code || !state) {
        if (active) setError('Google sign-in could not be verified. Please try again.');
        return;
      }

      try {
        await completeProviderSignIn('google', code, state);
        showToast('Signed in');
        navigate(
          useAuthStore.getState().appAccess === 'granted' ? paths.dashboard : paths.upgrade,
          { replace: true }
        );
      } catch (err) {
        if (!active) return;
        setError(err instanceof ApiError ? err.message : 'Google sign-in could not be completed.');
      }
    }

    void run();
    return () => {
      active = false;
    };
  }, [completeProviderSignIn, location.search, navigate, showToast]);

  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 16px',
        background: c.bg,
        color: c.text1,
        fontFamily: 'Inter, sans-serif',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 420,
          background: c.surface1,
          border: `1px solid ${c.border}`,
          borderRadius: 14,
          padding: '24px 22px',
          textAlign: 'center',
        }}
      >
        <h1
          style={{
            fontFamily: 'Space Grotesk',
            fontWeight: 600,
            fontSize: 18,
            margin: '0 0 8px',
            color: c.text1,
          }}
        >
          Completing Google sign-in…
        </h1>
        {error ? (
          <p role="alert" style={{ fontSize: 12, color: c.danger, margin: 0 }}>
            {error}
          </p>
        ) : (
          <p style={{ fontSize: 12, color: c.text3, margin: 0 }}>
            Please wait while we verify your account.
          </p>
        )}
      </div>
    </div>
  );
}
